<template>
  <div class="c-highlights">
    <div v-if="hasChapters && filteredHighlights.length > 0">
      <div v-for="(item, i) in filteredHighlights" :key="item.title + i" class="c-highlights__item">
        <h3 class="c-hightlights__title">
          {{ item.title }}
        </h3>

        <div class="c-highlights__list">
          <router-link
            class="c-highlights__highlight"
            v-for="highlight in item.elements"
            :key="highlight.id"
            :to="{ params: { page: highlight.page }}"
            @click.native="closeModal()"
            :aria-label="`${$t('GO_TO')} ${$t('HIGHLIGHT')}`"
          >
            <div class="c-highlights__highlight-heading">
              <div class="c-highlights__highlight-sentence">
                ... {{ highlight.quote }}...
              </div>

              <div class="c-highlights__highlight-page">
                {{ highlight.page }}
              </div>
            </div>

            <div class="c-highlights__highlight-info">
              {{ highlight.created | formatDate }}
            </div>
          </router-link>
        </div>
      </div>
    </div>

    <div v-else-if="!hasChapters && highlights.length > 0">
      <div class="c-highlights__item">
        <h3 class="c-hightlights__title">
          {{ bookTitle }}
        </h3>

        <div class="c-highlights__list">
          <router-link
            class="c-highlights__highlight"
            v-for="highlight in highlights"
            :key="highlight.id"
            :to="{ params: { page: highlight.page }}"
            @click.native="closeModal()"
            :aria-label="`${$t('GO_TO')} ${$t('HIGHLIGHT')}`"
          >
            <div class="c-highlights__highlight-heading">
              <div class="c-highlights__highlight-sentence">
                ... {{ highlight.quote }}...
              </div>

              <div class="c-highlights__highlight-page">
                {{ highlight.page }}
              </div>
            </div>

            <div class="c-highlights__highlight-info">
              {{ highlight.created | formatDate }}
            </div>
          </router-link>
        </div>
      </div>
    </div>

    <div v-else class="c-highlights__empty">
      {{ $t('HIGHLIGHTS_NO_CONTENT') }}
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'

import filteredItems from '@/utils/filterItemsByChapters'
import { checkChapters } from '@/utils/utils'

export default {
  name: 'Highlights',

  data() {
    return {
      hasChapters: false
    }
  },

  computed: {
    filteredHighlights() {
      return filteredItems(this.toc, this.highlights, this.pagesRange)
    },

    ...mapState('book', {
      bookTitle: state => state.book.title,
      toc: state => state.toc,
      pagesRange: state=> state.book.content.length
    }),

    ...mapGetters({
      highlights: 'annotations/getHighlights'
    })
  },

  mounted() {
    this.hasChapters = !checkChapters(this.toc)
  },

  updated() {
    this.hasChapters = !checkChapters(this.toc)
  },

  methods: {
    ...mapActions({
      closeModal: 'bookMenu/closeModal'
    })
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_vars.scss';
@import '@/assets/scss/_mixin.scss';

.c-highlights__item {
  border-bottom: 1px solid rgba($dark-grey, 0.8);
  margin-top: 1.2em;

  &:first-child {
    margin-top: 0;
  }

  &:last-child {
    border-bottom: none;
  }
}

.c-hightlights__title {
  font-size: 18px;
  font-weight: 700;
  color: $dark-blue;
}

.c-highlights__highlight {
  display: block;
  border-bottom: 1px solid rgba($dark-grey, 0.1);
  padding-bottom: 1.2em;
  padding-top: 1.2em;
  position: relative;
  cursor: pointer;

  &:first-child {
    margin-top: 1.2em;
  }

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    &:after {
      content: '';
      position: absolute;
      left: -1.8em;
      right: -1.8em;
      bottom: 0;
      top: 0;
      background: rgba($light-grey-blue, 0.2);
      border-radius: 2em;
    }
  }

  @include a11yOutline();
}

.c-highlights__highlight-heading {
  display: flex;
  color: $dark-blue;
}

.c-highlights__highlight-sentence {
  background: rgba($yellow-highlight, 0.25);
  font-style: italic;
}

.c-highlights__empty {
  @include empty();
}

.c-highlights__highlight-page {
  margin-left: auto;
  font-weight: 700;
}

.c-highlights__highlight-info {
  text-align: right;
  color: $dark-blue;
  font-size: 0.75em;
  margin-top: 1em;
}
</style>
